/* eslint-disable react/prop-types */

// useTableData.js
import { createColumnHelper } from '@tanstack/react-table';
import React, { useMemo } from 'react';

const fuzzyFilter = (row, columnId, filterValue) => {
  const value = row.getValue(columnId);
  if (value === null || value === undefined) return false;

  const searchValue = String(filterValue).toLowerCase().trim();
  const cellValue = String(value).toLowerCase().trim();

  return cellValue.includes(searchValue);
};

export const useTableData = (data = []) => {
  const columns = useMemo(() => {
    if (!data || data.length === 0) return [];

    return Object.keys(data[0])
      .filter(
        key =>
          !key.includes('_color') &&
          key !== 'farm_id' &&
          key !== 'id' &&
          !key.startsWith('section_') &&
          key !== 'modalButtons' &&
          key !== 'extra'
      )
      .map(key => ({
        id: key,
        accessorKey: key,
        header: key
          .replace(/_/g, ' ')
          .replace(/(^\w|\b\w(?![^()]*\)))/g, c => c.toUpperCase()),
        cell: ({ getValue, row }) => {
          const value = getValue();
          const colorKey = `${key}_color`;
          let displayValue =
            typeof value === 'object' && value !== null
              ? ' - '
              : value === 'NA' || value === null
              ? ' - '
              : value;

          if (
            typeof value === 'string' &&
            value.includes('<a') &&
            value.includes('href=')
          ) {
            const match = value.match(/href="([^"]+)"/);
            const href = match?.[1];
            if (href) {
              return (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: row.original[colorKey],
                    textDecoration: 'underline'
                  }}
                >
                  View Map
                </a>
              );
            }
          }

          return (
            <span
              title={displayValue || ''}
              style={{
                color: row.original[colorKey] || 'inherit',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: 'inline-block',
                maxWidth: '100%'
              }}
            >
              {displayValue || ''}
            </span>
          );
        },
        enableColumnFilter: true,
        filterFn: 'fuzzy'
      }));
  }, [data]);

  return { columns, fuzzyFilter };
};
